import { ref } from 'vue';

export const useSpinner = () => {
  const isLoading = ref(false);

  const start = () => {
    isLoading.value = true;
  };
  const stop = () => {
    isLoading.value = false;
  };
  const toggle = () => {
    isLoading.value = !isLoading.value;
  };

  return {
    isLoading,
    start,
    stop,
    toggle,
  };
};
